import { BookOpenIcon } from '@heroicons/react/outline';
import { Button } from 'components/atoms/Button';
import { Tooltip } from 'components/atoms/Tooltip';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { color } from 'types/shared/worlds';

type PriceListButtonProps = {
  onClick: () => void;
  disabled?: boolean;
  color?: color;
  tooltipContent?: string;
};

const PriceListButton: FC<PriceListButtonProps> = (props) => {
  const { t } = useTranslation();

  const tooltipContent =
    props.tooltipContent || t('invoice.form.add_item_from_catalog');

  return (
    <Tooltip content={tooltipContent} placement="topRight" hoverable={false}>
      <Button
        disabled={props.disabled}
        structure="light"
        size="xs"
        color={props.color}
        onClick={props.onClick}
        iconOnly
      >
        <BookOpenIcon className="w-5 h-5 mx-auto" strokeWidth={1.5} />
      </Button>
    </Tooltip>
  );
};

export default PriceListButton;
